// Mouvement : l'apparition douce, le compteur et le bandeau d'animaux sont désactivés si le visiteur a demandé
// « réduire les animations » (prefers-reduced-motion) — les contenus restent affichés, simplement sans mouvement.
export function prefersReducedMotion() {
    return typeof window !== "undefined" && typeof window.matchMedia === "function"
        && Boolean(window.matchMedia("(prefers-reduced-motion: reduce)").matches);
}

export const hasIntersectionObserver = () => typeof IntersectionObserver === "function";
